/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_No_Folder_SelectedInputs */



/**
* | output |
* | --- |
* | "No folder selected" |
*
* @param {Image_Export_No_Folder_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_no_folder_selected = /** @type {((inputs?: Image_Export_No_Folder_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_No_Folder_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun dossier selectionne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Ordner ausgewählt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna cartella selezionata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Папка не выбрана")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay ninguna carpeta seleccionada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未选择文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォルダが選択されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई फ़ोल्डर चयनित नहीं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma pasta selecionada")
	return /** @type {LocalizedString} */ ("No folder selected")
});